import React from 'react';

export const StarIcon = ({className, classNameContainer}) => {
  return <div className={classNameContainer}>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
      <path className={className} fillRule="evenodd" stroke="#2194FF" strokeWidth=".5" d="M12.64 15.568l-.648-5.244.062-.198 3.466-3.854-4.948-.974-.173-.13L8 .542 5.601 5.167l-.173.13-4.948.975 3.466 3.854.062.198-.647 5.244 4.527-2.26h.224l4.527 2.26z"/>
    </svg>
  </div>
};

